import { createApi } from "@reduxjs/toolkit/query/react";
import { ReportDocument, CompanyInfo, CompanyInfoError } from "features/compraPkb/types/report";
import { baseAppQuery } from "shared/api/baseQuery";
import { snackbarOnQueryStarted } from "middleware/snackbarOnQueryStarted";
import { pkbOnQueryStarted } from "middleware/pkbOnQueryStarted";

const ENDPOINT = "/report";
const reportApi: any = createApi({
  reducerPath: "reportApi",
  baseQuery: baseAppQuery,
  keepUnusedDataFor: 0,
  refetchOnMountOrArgChange: true,
  tagTypes: ["report"],
  endpoints: (builder) => ({
    getReportList: builder.query<ReportDocument[], string>({
      query: (applicationId) => `${ENDPOINT}/${applicationId}`,
      providesTags: ["report"],
    }),
    getCompanyInfo: builder.query<CompanyInfo|CompanyInfoError, string>({
      query: (iinBin) => `${ENDPOINT}/company-info/${iinBin}`,
      providesTags: ["report"],
    }),
    requestPkbReport: builder.mutation<
      undefined,
      { clientIinBin: string; applicationId: string }
    >({
      query: ({ clientIinBin, applicationId }) => ({
        url: `${ENDPOINT}/request-pkb/${clientIinBin}/${applicationId}`,
        method: "POST",
      }),
      invalidatesTags: ["report"],
      onQueryStarted: pkbOnQueryStarted({})
    }),
    requestKompraReport: builder.mutation<
      undefined,
      { clientIinBin: string; applicationId: string }
    >({
      query: ({ clientIinBin, applicationId }) => ({
        url: `${ENDPOINT}/request-kompra/${clientIinBin}/${applicationId}`,
        method: "POST",
      }),
      invalidatesTags: ["report"],
      onQueryStarted: snackbarOnQueryStarted({
        successMessage:"kompraReportSuccess",
        errorMessage:"kompraReportError",
      })
    }),
  }),
});

export const {
  useGetReportListQuery,
  useGetCompanyInfoQuery,
  useLazyGetCompanyInfoQuery,
  useRequestPkbReportMutation,
  useRequestKompraReportMutation,
} = reportApi;
export default reportApi;
